module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/incoming-box-3e4a0c0b13eecd5807bc46276d048a3b.svg";